module.exports = __webpack_public_path__ + "static/media/noFight.ce7e71a0.png";